module.exports = __webpack_public_path__ + "static/media/badminton-ireland.914807b2.png";